import * as React from 'react';
import { AccountFoundPage } from '../../pages/account-found/AccountFoundPage';
import { History } from 'history';
import { LiveChat } from 'ts/components/LiveChat';
import { useAppContext } from '../../../../contexts/app/AppContext';
import { useEffect } from 'react';

interface ForgotUsernameAccountFoundPageProps {
  history: History;
  location: Location;
}

const ForgotUsernameAccountFoundPage: React.FC<ForgotUsernameAccountFoundPageProps> = ({
  history,
  location,
}) => {
  const { setShowLiveChatWidget } = useAppContext();

  useEffect(() => {
    setShowLiveChatWidget(true);
  }, []);

  return (
    <>
      <AccountFoundPage history={history} location={location} />
      <LiveChat />
    </>
  );
};

export { ForgotUsernameAccountFoundPage };
